export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  if (config.public.APP_ENV === "playwright") {
    nuxtApp.vueApp.config.errorHandler = (error) => {
      console.error(error);
    };
  }
});
